<div class="container">
  <div class="row message ">
    <div class="col-md-12 p-0 " style="display: flex;" (click)="viewMail()">
      <span class="message-pic">
        <img [src]="inbox.img_path && inbox.img_path != '' ? inbox.img_path : 'assets/default_dp.png'" alt="No Image"
          height="40px" width="40px">
        <div class="text-center" style="height: 30px;" *ngIf='!on_view_click'>
          <i *ngIf="inbox.is_mail>=0" matTooltip="E-Mail" class="fa fa-envelope m-1 pointer" style="font-size: 9pt;"
            [ngStyle]="{'color':inbox.is_mail == 1 ? '#ff7112' :'#555' }"></i>
          <!--color: #ff7112;-->
          <i *ngIf="inbox.is_sms >=0" matTooltip="SMS" class="fa fa-comments m-1 pointer" style="font-size: 9pt;"
            [ngStyle]="{'color':inbox.is_sms == 1 ? '#ff7112' :'#555' }"></i>
        </div>
      </span>
      <div style="display: grid;width: 100%;margin-left: 6px;">
        <span style="font-size: 14px;display: grid;">
          <span>
            <strong>{{inbox.from_name}} </strong>
            <i class="fa fa-external-link float-right pointer" style="font-size: 12pt;color: #12699e;"
              (click)="openModelView()"></i>

          </span>
          <span style="font-size: 11px;">
            to {{inbox.to_name}}

            <span class="message-time">
              {{inbox.mail_sent_date | UtcToLocalTime | date: 'd-MMM-yyyy h:mm a'}}

              <!-- <span *ngIf="inbox.is_sent>=0">
                                <i class="fa fa-check fa-fw" aria-hidden="true"></i>
                            </span> -->
            </span>

          </span>
          <span *ngIf="inbox.stage_title" matTooltip="Stage - Status" style="font-size: 11px;">
            {{inbox.stage_title}}
            <span *ngIf="inbox.status_title">
              ({{inbox.status_title}})
            </span>
          </span>
        </span>
        <div class="message-content" *ngIf="!on_view_click">
          <p class="m-0" style="display: flex;height: 20px !important;"
            [innerHtml]="(inbox.subject ? (inbox.subject | HTMLFormatter) + '-' : '') + (inbox.mail_body ? (inbox.mail_body | HTMLFormatter) : '')">
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-12 mt-1">
      <div *ngIf="on_view_click" #DestoryDirective>
        <div DestoryDirective [afterViewInit]="afterViewInitRef">
          <div class="message-view" *ngIf="inbox.is_mail>=0">
            <i matTooltip="E-Mail" class="fa fa-envelope m-1 pointer" style="font-size: 9pt;"
              [ngStyle]="{'color':inbox.is_mail == 1 ? '#ff7112' :'#555' }"></i>
            <p class="m-0 pb-3" [innerHtml]="inbox.subject | HTMLFormatter">
            </p>
            <p class="m-0 message-body" [innerHtml]="inbox.mail_body | HTMLFormatter">
            </p>
          </div>
          <div class="message-view" *ngIf="inbox.is_sms >=0">
            <i matTooltip="SMS" class="fa fa-comments m-1 pointer" style="font-size: 9pt;"
              [ngStyle]="{'color':inbox.is_sms == 1 ? '#ff7112' :'#555' }"></i>
            <p class="m-0 pb-3" [innerHtml]="inbox.subject | HTMLFormatter">
            </p>
            <p class="m-0 message-body" [innerHtml]="inbox.sms_body | HTMLFormatter">
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
